import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://api.mescout.org/api/'
});

export default instance;


// WEBPACK FOOTER //
// ./src/axios-orders.js